import React from 'react';
import cx from 'classnames';
import { TableRow, TableCell, Typography } from '@material-ui/core';

import { CustomSwitch } from 'src/components/CustomSwitch';
import { IconDot } from 'src/assets/icons/Dot';
import { ACCOUNT_TABLE_COLUMNS } from '../AccountsTable';
import { useStyles } from './useStyles';

export const AccountRow = ({ account, onAccountClick, isChecked, isConnected }) => {
  const styles = useStyles();

  return (
    <TableRow
      key={account.id}
      className={styles.root}
      tabIndex={-1}
    >
      <TableCell className={styles.cell}>
        <CustomSwitch
          className={styles.switch}
          classes={{
            track: styles.track,
          }}
          color="primary"
          checked={isChecked}
          onChange={() => onAccountClick(account)}
        />
      </TableCell>
      {ACCOUNT_TABLE_COLUMNS.slice(1, 3).map((column) => {
        const value = account[column.field];
        return (
          <TableCell
            key={column.field}
            className={styles.cell}
          >
            <Typography className={styles.cellText}>{value}</Typography>
          </TableCell>
        );
      })}

      <TableCell
        className={cx(styles.cell, styles.statusCell, { [styles.connected]: isConnected })}
      >
        <IconDot className={styles.dotIcon} />
        <Typography className={styles.cellText}>
          {isConnected ? 'Connected' : 'Disconnected'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
